module.exports = __webpack_public_path__ + "static/img/council.ceb929a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/council.png
// module id = 8Yay
// module chunks = 1